import { makeContext } from "@shared/utils/makeContext";
import { Article, Category } from "../support.types";

// --- Name ---
const NAME = "Support";

// --- Types ---
export type SupportState = {
  articles: Article[];
  categories: Category[];
  isLoading: boolean;
  isSheetOpen: boolean;
  sheetArticleId: string | null;
};

export type SupportAction = {
  type: string;
  payload?: Partial<SupportState>;
};

// --- Constants ---
export const SUPPORT_SET = "support/set" as const;
export const SUPPORT_SET_LOADING = "support/set/loading" as const;
export const SUPPORT_SET_SHEET_OPEN = "support/set/sheet/open" as const;
export const SUPPORT_SET_SHEET_CLOSE = "support/set/sheet/close" as const;
export const SUPPORT_SET_SHEET_ARTICLE_ID =
  "support/set/sheet/article/id" as const;

export const ACTION_TYPES = {
  SUPPORT_SET,
  SUPPORT_SET_LOADING,
  SUPPORT_SET_SHEET_OPEN,
  SUPPORT_SET_SHEET_CLOSE,
  SUPPORT_SET_SHEET_ARTICLE_ID,
} as const;

// --- Initial State ---
export const initialSupport: SupportState = {
  articles: [],
  categories: [],
  isLoading: false,
  isSheetOpen: false,
  sheetArticleId: null,
};

// --- Reducer ---
function supportReducer(
  state: SupportState,
  action: SupportAction
): SupportState {
  switch (action.type) {
    case SUPPORT_SET:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };
    case SUPPORT_SET_LOADING:
      return {
        ...state,
        isLoading: action.payload?.isLoading ?? false,
      };
    case SUPPORT_SET_SHEET_OPEN:
      return {
        ...state,
        isSheetOpen: true,
        sheetArticleId: action.payload?.articleId,
      };
    case SUPPORT_SET_SHEET_CLOSE:
      return {
        ...state,
        isSheetOpen: false,
        sheetArticleId: null,
      };
    case SUPPORT_SET_SHEET_ARTICLE_ID:
      return {
        ...state,
        isSheetOpen: true,
        sheetArticleId: action.payload?.articleId,
      };
    default:
      throw new Error("Unknown action: " + action.type);
  }
}

// --- Context Creation ---
export const {
  Provider: SupportProvider,
  useState: useSupport,
  useDispatch: useSupportDispatch,
} = makeContext<SupportState, SupportAction>({
  name: NAME,
  initialState: initialSupport,
  reducer: supportReducer,
});
